import {
    FETCH_BACNET_INVENTORY,
    FETCH_INVENTORY,
    INVENTORY_LOAD_BEGIN,
    INVENTORY_LOAD_END,
    INVENTORY_LOAD_ERROR,
    INVENTORY_RESET,
    INVENTORY_TOGGLE_SELECT,
    INVENTORY_UPDATE
} from '../actions/actionTypes';

let selectedOBIXPath = null;
if (window) {
    const initialParams = new URLSearchParams(window.location.search);
    selectedOBIXPath = initialParams.get('selectedOBIXPath');
}

const initialState = {
    error:            null,
    bacnetInventory:  [],
    inventory:        {},
    lastRequestId:    null,
    loading:          false,
    selectedOBIXPath: selectedOBIXPath,
    treeCacheId:      performance.now(),
    updatedAt:        null
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_BACNET_INVENTORY:
            return {
                ...state,
                ...action.payload,
                updatedAt: new Date()
            };
        case FETCH_INVENTORY:
            return {
                ...state,
                ...action.payload,
                treeCacheId: performance.now(),
                updatedAt:   new Date()
            };
        case INVENTORY_LOAD_BEGIN:
            return {
                ...state,
                error:   initialState.error,
                loading: true
            };
        case INVENTORY_LOAD_END:
            return {
                ...state,
                loading: false
            };
        case INVENTORY_LOAD_ERROR:
            return {
                ...state,
                error: action.payload
            };
        case INVENTORY_RESET:
            return {
                ...initialState,
                treeCacheId: performance.now()
            };
        case INVENTORY_TOGGLE_SELECT:
            return {
                ...state,
                selectedOBIXPath: action.payload
            };
        case INVENTORY_UPDATE: {
            const { id, patch } = action.payload;
            return {
                ...state,
                inventory: {
                    ...state.inventory,
                    [id]: {
                        ...state.inventory[id],
                        ...patch
                    }
                },
                treeCacheId: performance.now()
            };
        }
        default:
            return state;
    }
};
